export const DEV_MODE = process.env.NODE_ENV !== "production";
export const FEATURES = {
  USER: {
    HOME: DEV_MODE,
  },
};
